import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog } from "../../components/dialog/dialogSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
} from "@progress/kendo-react-grid";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import AlertBox from "../../components/common/AlertBox";
import {
  formatIndianNumber,
  // checkAcessRights,
  getYearsArray,
} from "../../_helper/helper";
import {
  MONTHS_MAP,
  // PRINT_ACCESS
} from "../../_contstants/common";
import { clearSalaryGenerationList } from "./salryGenerationSlice";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { getAllActiveEmployee } from "../employee/services/employee.services";
import { IEmployee } from "../employee/employeeModel";
import { getEmployeeSalaryByIDYear } from "./services/salaryGeneration.services";
// import { Button } from "@progress/kendo-react-buttons";

const SalaryGenerationView: React.FC = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getAllActiveEmployee());
    return () => {
      dispatch(closeDialog());
      dispatch(clearSalaryGenerationList());
    };
  }, []);

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Salary View
          </Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <GeneratedSalaryViewFilter />
        </GridLayoutItem>
        <GridLayoutItem style={{ marginTop: 20 }}>
          <SalaryGenerationViewGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 50 };

const SalaryGenerationViewGridComponent: React.FC = () => {
  // const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  const SalaryGenerationList = useAppSelector(
    (state) => state.salarygeneration.SalaryGenerationList
  );
  const [expandedRow, setExpandedRow] = React.useState(null);

  const loading = useAppSelector((state) => state.retailer.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? SalaryGenerationList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  // const MyEditCommandCell = (props: GridCellProps) => {
  //   const printSalarySlipTable = (props: any) => {
  //     const state = {
  //       department_id: props.department_id,
  //       payout_month: props.payout_month,
  //       payout_year: props.payout_year,
  //     };
  //     sessionStorage.setItem("salaryslipsState", JSON.stringify(state));

  //     const reportTab = window.open("/salaryslips", "_blank");

  //     const interval = setInterval(() => {
  //       if (reportTab?.closed) {
  //         // Clear the session storage when the tab is closed
  //         sessionStorage.removeItem("salaryslipsState");
  //         clearInterval(interval);
  //       }
  //     }, 1000);
  //   };

  //   return (
  //     <td className="action-td">
  //       {isPrintAccess && (
  //         <Button
  //           style={{ marginRight: 5 }}
  //           type="button"
  //           fillMode={"solid"}
  //           themeColor={"primary"}
  //           onClick={() => printSalarySlipTable({})}
  //         >
  //           Print
  //         </Button>
  //       )}
  //     </td>
  //   );
  // };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 28 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const gridRef = useRef<any>(null);
  if (loading) return <LoadingPanel gridRef={gridRef} />;

  const truncateRemarks = (remarks: string) => {
    if (!remarks) return "";
    const maxLength = 100;
    if (remarks.length <= maxLength) return remarks;
    return remarks.substring(0, maxLength) + "...";
  };

  return (
    <>
      {SalaryGenerationList && SalaryGenerationList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          className="salary-view-table responsive-table"
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(SalaryGenerationList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : SalaryGenerationList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={SalaryGenerationList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [10, 25, 50, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Date"
            title="Date"
            width={180}
            cell={(props: GridCellProps) => {
              return (
                <td>
                  <span style={{ textTransform: "uppercase" }}>
                    {MONTHS_MAP[+props?.dataItem?.payout_month] || ""}{" "}
                  </span>
                  {" - "}
                  {props?.dataItem?.payout_year}
                </td>
              );
            }}
          />
          <Column
            field="total_days"
            title="Total Days"
            className="cell-salary"
            width={120}
          />
          <Column field="working_days" title="Working Days" width={130} />
          <Column field="present_days" title="Present Days" width={130} />
          <Column field="casual_leave" title="Casual Leave" width={130} />

          <Column
            field="basic"
            title="Basic"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.basic
                  ? formatIndianNumber(props.dataItem?.basic || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="hra"
            title="HRA"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.hra
                  ? formatIndianNumber(props.dataItem?.hra || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="wash"
            title="Wash"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.wash
                  ? formatIndianNumber(props.dataItem?.wash || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="prod_ins_all"
            title="Prod .Inc. All"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.prod_ins_all
                  ? formatIndianNumber(props.dataItem?.prod_ins_all || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="adv_bonus"
            title="Advance Bonus"
            width={140}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.adv_bonus
                  ? formatIndianNumber(props.dataItem?.adv_bonus || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="adv_leave"
            title="Advance Leave"
            width={140}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.adv_leave
                  ? formatIndianNumber(props.dataItem?.adv_leave || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="adv_std_be"
            title="Adv. Std. Be"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.adv_std_be
                  ? formatIndianNumber(props.dataItem?.adv_std_be || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="food"
            title="Food"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.food
                  ? formatIndianNumber(props.dataItem?.food || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="da"
            title="DA"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.da
                  ? formatIndianNumber(props.dataItem?.da || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="other_earning"
            title="Other Earning"
            width={150}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.other_earning
                  ? formatIndianNumber(props.dataItem?.other_earning || 0)
                  : 0}
              </td>
            )}
          />

          <Column
            field="pf"
            title="PF"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.pf
                  ? formatIndianNumber(props.dataItem?.pf || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="esi"
            title="ESI"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.esi
                  ? formatIndianNumber(props.dataItem?.esi || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="it"
            title="IT"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.it
                  ? formatIndianNumber(props.dataItem?.it || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="pt"
            title="PT"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.pt
                  ? formatIndianNumber(props.dataItem?.pt || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="loan"
            title="Loan"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.loan
                  ? formatIndianNumber(props.dataItem?.loan || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="advance"
            title="Advance"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.advance
                  ? formatIndianNumber(props.dataItem?.advance || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="lwf"
            title="LWF"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.lwf
                  ? formatIndianNumber(props.dataItem?.lwf || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="tds"
            title="TDS"
            width={120}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.tds
                  ? formatIndianNumber(props.dataItem?.tds || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="other"
            title="Other Deduction"
            width={150}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.other
                  ? formatIndianNumber(props.dataItem?.other || 0)
                  : 0}
              </td>
            )}
          />

          <Column
            field="total_income"
            title="Total Earning"
            width={130}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.total_income
                  ? formatIndianNumber(props.dataItem?.total_income || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="total_deduction"
            title="Total Deduction"
            width={150}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.total_deduction
                  ? formatIndianNumber(props.dataItem?.total_deduction || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="payable_amount"
            title="Total Payable Amount"
            width={200}
            cell={(props: any) => (
              <td className="text-end">
                {props.dataItem?.payable_amount
                  ? formatIndianNumber(props.dataItem?.payable_amount || 0)
                  : 0}
              </td>
            )}
          />
          <Column
            field="remarks"
            title="Remarks"
            width={250}
            cell={(props: any) => (
              <td>
                <div
                  className="remarks-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      expandedRow === props.dataItem?.id
                        ? props.dataItem?.remarks
                        : truncateRemarks(props.dataItem?.remarks),
                  }}
                />
                {props.dataItem?.remarks.length > 100 && (
                  <span
                    className="readmore-btn"
                    onClick={() =>
                      setExpandedRow(
                        expandedRow === props.dataItem?.id
                          ? null
                          : props.dataItem?.id
                      )
                    }
                  >
                    {expandedRow === props.dataItem?.id
                      ? "Read Less"
                      : "Read More"}
                  </span>
                )}
              </td>
            )}
          />
          {/* {isPrintAccess && (
            <Column
              field="retailer_guid"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              filterable={false}
              locked={true}
            />
          )} */}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const GeneratedSalaryViewFilter: React.FC = () => {
  const dispatch = useAppDispatch();
  const EmployeeList = useAppSelector((state) => state.employee.EmployeeList);
  const SalaryGenerationViewFilter = useAppSelector(
    (state) => state.salarygeneration.SalaryGenerationViewFilter
  );
  const loading = useAppSelector((state) => state.salarygeneration.loading);
  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        employee_id: values?.employee_id,
        year: values?.year,
      };
      await dispatch(getEmployeeSalaryByIDYear(payload));
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={SalaryGenerationViewFilter}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="d-flex gap-3" style={{ width: "50%" }}>
              <Field
                name="year"
                label="Year"
                wrapperStyle={{ width: "30%" }}
                placeholder="Select Year"
                component={FormSelectionField}
                options={getYearsArray(2000, new Date().getFullYear() + 1)
                  ?.reverse()
                  ?.map((year: any) => {
                    return {
                      value: year?.value,
                      label: year?.label,
                    };
                  })}
                validator={requiredValidator}
                astrike={true}
              />
              <Field
                name="employee_id"
                label="Employee"
                wrapperStyle={{ width: "50%" }}
                placeholder="Select Employee"
                component={FormSelectionField}
                options={EmployeeList.map((emp: IEmployee) => ({
                  value: emp.id,
                  label: emp.name,
                }))}
                validator={requiredValidator}
                astrike={true}
              />
              <ButtonWithLoading
                buttonStyle={{ marginTop: 35, width: "20%" }}
                label={"View"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || loading}
                loading={loading}
              />
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default SalaryGenerationView;
